import type { Delegation } from "../wallet/wallet";
import { validityLabel } from "../wallet/present";
import { shortDid } from "../util";
import { NameBasisBadge, type NameBasis } from "./NameBasisBadge";

/** An AuthorisedAttester delegation in the wallet: the issuer by its registry name
 *  (the DID as secondary text), the scope, and its validity in words. */
export function DelegationCard({ d, issuerName, basis, domain, now, locale }: { d: Delegation; issuerName?: string | null;
  basis?: NameBasis | null; domain?: string | null; now?: number; locale?: string }) {
  const v = validityLabel(d.validFrom, d.validUntil, now, locale);
  return (
    <div className="card" data-testid="delegation" data-validity={v.state} style={{ marginBottom: 8 }}>
      <b>{d.role}</b> for {issuerName ? <><b data-testid="delegation-issuer">{issuerName}</b> <NameBasisBadge basis={basis} domain={domain} /></> : <span className="mono" data-testid="delegation-issuer">{shortDid(d.issuer)}</span>}
      {issuerName && <div className="hint mono">{d.issuer}</div>}
      <div className="hint">Scope: {d.scope.join(", ")} · <span data-testid="delegation-validity">{v.text}</span></div>
    </div>
  );
}
